import Card from '@material-ui/core/Card';
import React from 'react';
import { CardContent, Divider } from '@material-ui/core';
import { useContent, useFindToken, useFindUniqueCTX } from '../../hooks/token-manager';

const DummyTraitCard = (
  {
    trait,
    category,
  },
) => {
  const { ctx: ctxTrait } = useFindUniqueCTX({ trait });
  const { ctx: ctxTraitCategory } = useFindUniqueCTX({ trait, category });

  const { token: traitTitleToken } = useFindToken('TRAIT_TITLE');
  const { token: traitSubtitleToken } = useFindToken('TRAIT_SUBTITLE');

  const { token: adviceToken } = useFindToken('ADVICE');

  const { content: traitTitle } = useContent(ctxTrait?.id, traitTitleToken?.id);
  const { content: traitSubtitle } = useContent(ctxTrait?.id, traitSubtitleToken?.id);
  const { content: advice } = useContent(ctxTraitCategory?.id, adviceToken?.id);

  return (
    <Card style={ { border: '1px solid green' } }>
      <h2>{traitTitle?.text}</h2>
      <h3>{traitSubtitle?.text}</h3>
      <Divider />
      <CardContent>
        {advice?.text}
      </CardContent>
    </Card>
  );
};

export default DummyTraitCard;
